import { render, staticRenderFns } from "./Equipo.vue?vue&type=template&id=3c90a398&scoped=true"
import script from "./Equipo.vue?vue&type=script&lang=js"
export * from "./Equipo.vue?vue&type=script&lang=js"
import style0 from "./Equipo.vue?vue&type=style&index=0&id=3c90a398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90a398",
  null
  
)

export default component.exports